/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { trainers } from "./content/trainer";

export default function Trainer(props) {
  return(
    <section id="trainers" className="trainers">
      <div className="bc">
    <div className="container aos-init aos-animate" data-aos="fade-up">

      <div className="section-title">
        <h2>Trainers</h2>
        <p>Our Professional Trainers
        <div className="custom-button" style={{display: "flex", flexDirection: "row-reverse", color: "white"}}>
        <a href={props.isPublic ? "/trainer" : "/trainers"} className="get-started-btn">See All</a>
        </div>
        </p>
      </div>
      <div className="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
      {trainers.map((trainer, index) => {
        return (
        <div key={index} className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="member">
            <img src={trainer.image} width="300" height="300" loading="lazy" alt="" />
            <div className="member-content">
              <h4>{trainer.name}</h4>
              <span>{trainer.subject}</span>
              <p>{trainer.vision}</p>
              {/* <div className="social">
                <a href=""><i className="icofont-twitter"></i></a>
                <a href=""><i className="icofont-facebook"></i></a>
                <a href=""><i className="icofont-instagram"></i></a>
                <a href=""><i className="icofont-linkedin"></i></a>
              </div> */}
            </div>
          </div>
        </div>)})}

        {/* <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="member">
            <img src="assets/img/trainers/trainer-2.jpg" className="img-fluid" alt="" />
            <div className="member-content">
              <h4>Sarah Jhinson</h4>
              <span>Marketing</span>
              <p>
                Repellat fugiat adipisci nemo illum nesciunt voluptas repellendus. In architecto rerum rerum temporibus
              </p>
              <div className="social">
                <a href=""><i className="icofont-twitter"></i></a>
                <a href=""><i className="icofont-facebook"></i></a>
                <a href=""><i className="icofont-instagram"></i></a>
                <a href=""><i className="icofont-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="member">
            <img src="assets/img/trainers/trainer-3.jpg" className="img-fluid" alt="" />
            <div className="member-content">
              <h4>William Anderson</h4>
              <span>Content</span>
              <p>
                Voluptas necessitatibus occaecati quia. Earum totam consequuntur qui porro et laborum toro des clara
              </p>
              <div className="social">
                <a href=""><i className="icofont-twitter"></i></a>
                <a href=""><i className="icofont-facebook"></i></a>
                <a href=""><i className="icofont-instagram"></i></a>
                <a href=""><i className="icofont-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div> */}

      </div>

    </div>
    </div>
  </section>
  );
}